export default __webpack_public_path__ + "static/media/1375.79c6725d.png";